export const randomStr = () => {
  return Math.random().toString(36).substr(2, 6);
};
